import { render, staticRenderFns } from "./GeneralDealListItem.vue?vue&type=template&id=4192fdc0&scoped=true&"
import script from "./GeneralDealListItem.vue?vue&type=script&lang=js&"
export * from "./GeneralDealListItem.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDealListItem.vue?vue&type=style&index=0&id=4192fdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4192fdc0",
  null
  
)

export default component.exports